import { render, staticRenderFns } from "./detail-full.vue?vue&type=template&id=1cb19b71"
import script from "./detail-full.vue?vue&type=script&lang=ts"
export * from "./detail-full.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports